import { useEffect, useState } from "react";
import { gxDashboardTodayApprovedCountApi } from "@/app/apiConfig/services/customerAbstractApiLayer";
import { useUserDetails } from "@/app/services/context/UserDetailsContext";
import { gxCurrencyFormat } from "@/app/utils/helpers/gxCurrencyFormat";

interface DashboardCardProps {
  title: string;
}

const ApprovedTodayCard = ({ title }: DashboardCardProps) => {
  const { userData } = useUserDetails();

  const [data, setData] = useState({
    totalApprovalCount: 0,
    totalAmount: 0,
    currency: "",
  });

  const currency = userData?.currencyCode as string;
  const formatted = gxCurrencyFormat(data.totalAmount, data.currency);

  useEffect(() => {
    if (!userData?.currencyCode) return;

    const fetchApprovedCount = async () => {
      try {
        const response = await gxDashboardTodayApprovedCountApi({
          filterBy: {
            filterKey: "Currency",
            filterValue: currency,
          },
        });

        if (response?.data) {
          setData(response.data);
        }
      } catch (err) {}
    };

    fetchApprovedCount();
  }, [userData?.currencyCode]);

  return (
    <div className="gx-alter-card">
      <h3 className="gx-alter-approval-header-text gx-p16-sb">{title}</h3>

      <span className="gx-alter-approval-text-value gx-36-sb">
        {data.totalApprovalCount}
      </span>

      <div className="gx-alter-approval-currency">
        <p className="alter-approval-policy-text_green gx-p14-b">
          {formatted.symbol}{" "}
        </p>

        <span className="alter-approval-policy-text_green gx-p14-b">
          {formatted.integer}
        </span>

        <span className="alter-approval-policy-text_green gx-p14-b">
          {formatted.decimal}
        </span>
      </div>
    </div>
  );
};

export default ApprovedTodayCard;
